import { useDispatch } from "react-redux";
import { useState } from "react";
import {
  Box,
  Stack,
  Typography,
  Button,
  List,
  ListItem,
  ListItemText,
  Container,
  Paper
} from "@mui/material";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import AccordionAfinando from "../../../UI/AccordionAfinando/AccordionAfinando";
import accordionOpen from "./../../../../assets/images/accordion_open.svg";
import accordionClose from "./../../../../assets/images/accordion_close.svg";
import sixteenOff from "./../../../../assets/images/16_off_annual.svg";
import CardTouch from "../../../UI/Card/CardTouch/CardTouch";

import { InfoOutlined } from "@mui/icons-material";


const CardPlan = ({
  updateTagUser,
  PlanName,
  PlanItems,
  PlanValueMonthly,
  PlanValueAnnual,
  changePropertyUrl
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const [expanded, setExpanded] = useState({
    AccordionOne: false,
    AccordionTwo: false,
    AccordionThree: false,
    AccordionFor: false,
    AccordionFive: false,
  });

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded((prevState) => ({
      ...prevState,
      [`Accordion${panel}`]: newExpanded ? [`Accordion${panel}`] : false,
    }));
  };

  const PeriodicityMonthly = () => {
    updateTagUser(["ASSINAR"])
    changePropertyUrl("mensal")
    dispatch({
      type: "PURCHASE",
      purchase: {
        content: "PaymentArea",
        step: "InvoiceData",
        errorList: []
      },
      PostData: {
        periodicity: "monthly",
      },
      planInfo: {
        value: PlanValueMonthly,
        planName: PlanName,
        planDescription: PlanItems,
        periodicity: "monthly"
      },
    });
  };

  const PeriodicityAnnual = () => {
    updateTagUser(["ASSINAR"])
    changePropertyUrl("anual")
    dispatch({
      type: "PURCHASE",
      purchase: {
        content: "PaymentArea",
        step: "InvoiceData",
        errorList: []
      },
      PostData: {
        periodicity: "annual",
      },
      planInfo: {
        value: PlanValueAnnual,
        planName: PlanName,
        planDescription: PlanItems,
        periodicity: "annual"
      },
    });
  };

  const theme = createTheme({
    palette: {
      ochre: {
        main: "#4e2d92",
        light: "#4e2d92",
        dark: "#4e2d92",
        contrastText: "#FFF",
      },
      ochreBack: {
        main: "#FFF",
        light: "#FFF",
        contrastText: "#4e2d92",
      },
    },
  });

  const cardTouchBaseStyles = {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    p: 3,
    textAlign: 'center',
    position: 'relative'
  };

  const annualCardStyles = {
    ...cardTouchBaseStyles,
    bgcolor: '#4e2d92',
    color: 'white',
    borderRadius: 2
  };

  const monthlyCardStyles = {
    ...cardTouchBaseStyles,
    bgcolor: 'white',
    color: 'black',
    borderRadius: 2,
    border: '1px solid #e0e0e0'
  };

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Paper elevation={0} sx={{ p: 0 }}>
        <Stack spacing={4}>
          <Stack direction={{ xs: 'column', md: 'row' }} spacing={4} alignItems="flex-start">
            <Stack
              direction={{ xs: 'column', sm: 'column', md: 'column' }}
              spacing={2}
              sx={{
                flex: 1,
                width: { xs: '100%', md: 'auto' }
              }}
            >
              <CardTouch
                transitionDelay={300}
                onClick={PeriodicityAnnual}
                sx={{ width: '100%' }}
              >
                <Box sx={annualCardStyles}>
                  <Box
                    component="img"
                    src={sixteenOff}
                    alt=""
                    sx={{
                      position: 'absolute',
                      top: { xs: 8, sm: 12 },
                      right: { xs: 8, sm: 12 },
                      width: { xs: '60px', sm: '80px' },
                      height: 'auto'
                    }}
                  />
                  <Typography variant="h6" component="div" sx={{ mb: 1, fontWeight: 'bold', color: 'white' }}>
                    Anual
                  </Typography>
                  <Typography data-testid="buy_planValueAnnual_text" variant="h4" component="div" sx={{ mb: 1, fontWeight: 'bold', color: 'white' }}>
                    {PlanValueAnnual}
                  </Typography>
                  <Typography variant="body2" sx={{ mb: 3, color: 'white' }}>
                    por ano
                  </Typography>
                  <Button
                    data-testid="buy_subscribeAnnually_btn"
                    sx={{
                      width: "100%",
                      fontWeight: "bold",
                      bgcolor: 'white',
                      color: '#4e2d92',
                      '&:hover': {
                        bgcolor: '#f5f5f5',
                      }
                    }}
                    variant="contained"
                  >
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                      {t("purchase.subscribe_annually")}
                    </Typography>
                  </Button>
                </Box>
              </CardTouch>

              <CardTouch
                transitionDelay={200}
                onClick={PeriodicityMonthly}
                sx={{ width: '100%' }}
              >
                <Box sx={monthlyCardStyles}>
                  <Typography variant="h6" component="div" sx={{ mb: 1, fontWeight: 'bold' }}>
                    Mensal
                  </Typography>
                  <Typography data-testid="buy_planValueMonthly_text" variant="h4" component="div" sx={{ mb: 1, fontWeight: 'bold' }}>
                    {PlanValueMonthly}
                  </Typography>
                  <Typography variant="body2" sx={{ mb: 3 }}>
                    por mês
                  </Typography>
                  <ThemeProvider theme={theme}>
                    <Button
                      data-testid="buy_subscribeAnnually_btn"
                      style={{ width: "100%", fontWeight: "bold", gap: "15px" }}
                      variant="contained"
                      color="ochre"
                    >
                      <Typography component="span" sx={{ fontWeight: 'bold' }}>
                        {t("purchase.subscribe_monthly")}
                      </Typography>
                    </Button>
                  </ThemeProvider>
                </Box>
              </CardTouch>
            </Stack>

            <Box sx={{ flex: 1 }}>
              <Typography variant="h6" component="h2" sx={{ mb: 2, fontWeight: 'bold', color: '#662d91' }}>
                {t("purchase.what_yoy_will_get_with_this_plan")}
              </Typography>
              {PlanItems && (
                <List sx={{ p: 0 }}>
                  {PlanItems.map((item, key) => (
                    <ListItem key={key} sx={{ px: 0, py: 0.5 }}>
                      <ListItemText
                        primary={`• ${item}`}
                        sx={{
                          '& .MuiListItemText-primary': {
                            fontSize: '0.875rem',
                            lineHeight: 1.5
                          }
                        }}
                      />
                    </ListItem>
                  ))}
                </List>
              )}
            </Box>
          </Stack>

          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 1,
              mt: 3,
              mx: 2,
              p: 2,
              backgroundColor: 'rgba(102, 45, 145, 0.1)',
              border: '1px solid #662D91',
              borderRadius: 1,
            }}
          >
            <InfoOutlined sx={{ color: '#662D91', fontSize: 20 }} />
            <Typography
              variant="body2"
              sx={{
                color: '#662D91',
                textAlign: 'center',
              }}
            >
              {t("purchase.cancel_your_plan_whenever_you_want")}
            </Typography>
          </Box>

          <Stack spacing={1}>
            <AccordionAfinando
              transitionDelay={400}
              expanded={expanded.AccordionOne}
              onChange={handleChange("One")}
              expandIcon={
                expanded.AccordionOne ? (
                  <img src={accordionClose} alt="" />
                ) : (
                  <img src={accordionOpen} alt="" />
                )
              }
              title={t("purchase.who_can_i_invite_as_a_user")}
              description={t("purchase.you_can_invite_anyone_to_be_a_user")}
            />
            <AccordionAfinando
              transitionDelay={400}
              expanded={expanded.AccordionTwo}
              onChange={handleChange("Two")}
              expandIcon={
                expanded.AccordionTwo ? (
                  <img src={accordionClose} alt="" />
                ) : (
                  <img src={accordionOpen} alt="" />
                )
              }
              title={t("purchase.how_does_the_subscription_work")}
              description={t("purchase.the_subscription_works_like_netflix_or_spotify")}
            />
            <AccordionAfinando
              transitionDelay={400}
              expanded={expanded.AccordionThree}
              onChange={handleChange("Three")}
              expandIcon={
                expanded.AccordionThree ? (
                  <img src={accordionClose} alt="" />
                ) : (
                  <img src={accordionOpen} alt="" />
                )
              }
              title={t("purchase.can_i_pay_by_credit_card")}
              description={t("purchase.yes_you_can_pay_by_credit_card")}
            />
            <AccordionAfinando
              transitionDelay={400}
              expanded={expanded.AccordionFor}
              onChange={handleChange("For")}
              expandIcon={
                expanded.AccordionFor ? (
                  <img src={accordionClose} alt="" />
                ) : (
                  <img src={accordionOpen} alt="" />
                )
              }
              title={t("purchase.how_do_statistics_work")}
              description={t("purchase.our_progress_tool_offers_detailed_statistics")}
            />
            <AccordionAfinando
              transitionDelay={400}
              expanded={expanded.AccordionFive}
              onChange={handleChange("Five")}
              expandIcon={
                expanded.AccordionFive ? (
                  <img src={accordionClose} alt="" />
                ) : (
                  <img src={accordionOpen} alt="" />
                )
              }
              title={t("purchase.what_are_goals_and_achievements")}
              description={t("purchase.when_you_reach_goals_you_receive_coins_to_unlock_exclusive_rewards_from_our_shop")}
            />
          </Stack>
        </Stack>
      </Paper>
    </Container>
  );
};

export default CardPlan;